import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useTaskTagsList() {

    //User toast
    const toast = useToast()

    const refTaskTagListTable = ref(null)

    const tableColumns = [
        {key: 'tag', sortable: true},
        {key: 'description'},
        {key: 'demo', label:'LABEL'},
        {key: 'action'}
    ]

    const perPage = ref(10)
    const totalTaskTags = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refTaskTagListTable.value ? refTaskTagListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalTaskTags.value,
        }
    })

    const refetchData = () => {
        refTaskTagListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchTaskTags = (ctx, callback) => {
        store.dispatch('setting-tasktag/fetchTaskTags',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {tasktags, total} = response.data
            callback(tasktags)
            totalTaskTags.value = total
        
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching task tags list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchTaskTags,
        tableColumns,
        perPage,
        currentPage,
        totalTaskTags,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refTaskTagListTable,
        ability,
        refetchData
    }

}